import { AppConfig } from '~/interfaces/AppConfig';
import { getOnpremHostname } from 'omni-package-react-core';

const getDomainName = () => {
  if (process.env.REACT_APP_DOMAIN_NAME) {
    return process.env.REACT_APP_DOMAIN_NAME;
  }

  return document.location.host;
};

const getOnpremHostnameByHost = () => {
  if (document.location.host === process.env.REACT_APP_DOMAIN_NAME_FR) {
    return process.env.REACT_APP_EXTRANET_DOMAIN_NAME_FR;
  }

  if (process.env.REACT_APP_EXTRANET_DOMAIN_NAME_EN) {
    return process.env.REACT_APP_EXTRANET_DOMAIN_NAME_EN;
  }

  return getOnpremHostname();
};

export default class Configuration {
  private static config: AppConfig = {
    homePath: '/eemwpnp1/public/gologin/',
    mockingEnabled: process.env.REACT_APP_MOCK_API === 'true',
    publicUrl: process.env.PUBLIC_URL,
    businessEntityCode: process.env.REACT_APP_BUSINESS_ENTITY_CODE,
    forgetPasswordPath: process.env.REACT_APP_FORGET_PASSWORD_PATH,
    forgetUserNamePath: process.env.REACT_APP_FORGET_USERNAME_PATH,
    registrationPath: process.env.REACT_APP_REGISTRATION_PATH,
    domainName: getDomainName(),
    onPremHostName: getOnpremHostnameByHost(),
    idpTenantUrl: process.env.REACT_APP_IDP_TENANT_URL,
  };

  public static Current(): AppConfig { return Configuration.config; }
}
